import { ShieldCheck, Lock, EyeOff } from "lucide-react";

type Variant = "letter" | "photo" | "payment" | "share" | "recipient" | "settings";

const COPY: Record<Variant, { icon: typeof ShieldCheck; title: string; body: string }> = {
  letter: {
    icon: Lock,
    title: "Private words deserve care.",
    body: "LRNSY treats letters as sensitive emotional content. We do not use private letter text for advertising profiling.",
  },
  photo: {
    icon: EyeOff,
    title: "Use photos with permission.",
    body: "Only upload images you own or have permission to use. This keeps the experience meaningful, respectful, and safe.",
  },
  payment: {
    icon: ShieldCheck,
    title: "Payment handled through trusted processors.",
    body: "LRNSY uses payment providers to process transactions and does not intentionally store full card details directly.",
  },
  share: {
    icon: Lock,
    title: "This link is private, not public.",
    body: "Share it only with the person you chose. Anyone with the link may be able to open the experience unless extra protection is enabled.",
  },
  recipient: {
    icon: ShieldCheck,
    title: "You are opening a private LRNSY experience.",
    body: "Take your time. LRNSY is built to preserve emotional trust and does not use private letters for ad profiling.",
  },
  settings: {
    icon: ShieldCheck,
    title: "You stay in control.",
    body: "Manage cookies, analytics, marketing preferences, local drafts, and privacy choices from this page.",
  },
};

export function PrivacyTrustNote({ variant }: { variant: Variant }) {
  const item = COPY[variant];
  const Icon = item.icon;

  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-2">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-white/10 text-amber-100">
          <Icon size={16} />
        </div>

        <div>
          <p className="text-[11px] font-black uppercase tracking-[0.22em] text-white/60">
            {item.title}
          </p>
          <p className=" text-xs leading-5 text-white/42">{item.body}</p>
        </div>
      </div>
    </div>
  );
}
